module.exports = __webpack_public_path__ + "img/Img22_210049_BjFj-101-15C6-1327.22a8781d.jpg";